import './App.css';
import {BrowserRouter, Route, Switch} from 'react-router-dom'
import LandingPage from './components/LandingPage'
import Cards from './components/Cards'
import RecipesDetail from './components/RecipesDetail'
import CreateRecipes from './components/CreateRecipes'

//envolvemos en el router
function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Switch>
          <Route exact path='/' component={LandingPage}/>
          <Route exact path='/Cards' component={Cards}/>
          <Route path='/recipes/:id' component={RecipesDetail }/>
          <Route path='/recipe' component={ CreateRecipes }/>
        </Switch>
      </div>
    </BrowserRouter>
  );
}

export default App;
